import React from 'react';
import { ChevronDownIcon } from '@heroicons/react/24/outline';
import { useTranslation } from '../../contexts/TranslationContext';

const LanguageSwitcher: React.FC = () => {
  const { language, setLanguage, availableLanguages } = useTranslation();

  const languages: Record<string, string> = {
    pl: 'Polski',
    en: 'English',
  };

  return (
    <div className="relative inline-block text-left w-full">
      <select
        value={language}
        onChange={(e) => setLanguage(e.target.value)}
        className="appearance-none bg-gray-50 border border-gray-200 rounded-md px-3 py-2 pr-8 text-sm text-gray-700 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-primary-500 hover:bg-gray-100 transition-colors w-full"
      >
        {availableLanguages.map((lang) => (
          <option key={lang} value={lang}>
            {languages[lang] || lang.toUpperCase()}
          </option>
        ))}
      </select>
      <ChevronDownIcon className="absolute right-2 top-1/2 transform -translate-y-1/2 h-4 w-4 text-gray-500 pointer-events-none" />
    </div>
  );
};

export default LanguageSwitcher;
